/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useState } from 'react';

import './animation008.less';

import ImgPoint from '../../../../../assets/animation_point.gif';
import AddPointIcon from '../../../../../assets/animation-arrow.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

import { Button, Modal } from 'antd';

interface IAnimation008SubItem {
  img: string;
  link: string;
  title: string;
  modaltitle: string;
  modallink: string;
}

interface IAnimation008Item {
  icon: string;
  title: string;
  content: string;
  tip?: string;
  subItems?: IAnimation008SubItem[];
}

const bgTemplate = [
  '#597EF7',
  '#0CA3A3',
  '#F26927',
  '#E7444E',
  '#343194',
  '#2C2281',
  '#E7444E',
  '#FFC53D',
  '#0CA3A3',
  '#0C53A3',
];

const getImg = (img: string) => require(`../../../../../assets/${img}`).default;

const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];

interface IAnimation008Props {
  items: IAnimation008Item[];
  style?: React.CSSProperties;
  title?: string | null;
  onCompleted?: () => void;
}

const Animation008: React.FunctionComponent<IAnimation008Props> = ({
  title,
  items,
  style,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  const rowCount = items.length <= 5 ? items.length : 5;

  const [isModalOpen, setModalOpen] = useState(false);

  const [currPage, setCurrPage] = useState(0);

  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };

  const [modalItem, setModalItem] = useState<IAnimation008SubItem[]>();

  const [show, setShow] = useState(true);

  return (
    <div ref={crrRef} className="animation008 component" style={{ margin: 0 }}>
      {title && (
        <div
          className="animation008-title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      <div className="animation008-content">
        {items.map((itm: IAnimation008Item, idx: number) => (
          <div
            key={idx}
            className={`animation008-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
            style={{
              width: `calc(${(1 / rowCount) * 100}% - 1rem)`,
              backgroundColor: getBG(idx),
            }}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            {itm.icon && (
              <div className={`small-icon ${!itm.title ? 'large' : ''}`}>
                <img src={getImg(itm.icon)} alt="" />
              </div>
            )}
            {itm.title && (
              <div
                className="animation008-top"
                dangerouslySetInnerHTML={{ __html: itm.title }}
              />
            )}
            <div className="animation008-text">
              <span dangerouslySetInnerHTML={{ __html: itm.content }} />
              {itm.subItems ? (
                <div>
                  <Button
                    className="view-more-btn"
                    onClick={() => {
                      setModalItem(itm.subItems);
                      setModalOpen(true);
                      setShow(false);
                    }}
                    type="link"
                  >
                    {itm.tip}
                  </Button>
                  <img
                    className="click-point1"
                    hidden={!show}
                    src={ImgPoint}
                    alt=""
                  />
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
      {modalItem && (
        <Modal
          width="60%"
          className="animation008-modal"
          title={
            <div className="animation008-modal-header">
              <div className="animation008-modal-title">
                {modalItem[currPage]?.modaltitle}
              </div>
              <div className="animation008-modal-link">
                <span className="link-label">
                  <img src={AddPointIcon} alt="" />
                  {modalItem[currPage]?.modallink}
                </span>
                <a
                  className="example-link"
                  href={modalItem[currPage]?.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {modalItem[currPage]?.title}
                </a>
              </div>
            </div>
          }
          footer={null}
          visible={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => setPage(-1)}
          >
            <img src={ImgArrowLeft} alt="" />
          </Button>
          <video
            src={
              require(`../../../../../assets/${modalItem[currPage]?.img}`)
                .default
            }
            controls
            autoPlay
          />
          <Button
            className={`next-button ${currPage === 1 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 1}
            onClick={() => setPage(1)}
          >
            <img src={ImgArrowRight} alt="" />
          </Button>
        </Modal>
      )}
    </div>
  );
};

Animation008.defaultProps = {
  style: {},
  title: null,
};

export default Animation008;
